import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("p", null, " Your teammates and team lead will need your permission to view your Solo and Viewpoints reports that you create while using Gyre. ", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { style: {"height":"20px"} }, null, -1)
const _hoisted_3 = { class: "clearfix" }
const _hoisted_4 = { style: {"float":"left","margin-top":"8px"} }
const _hoisted_5 = { style: {"float":"right"} }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", null, "You can change this later, in your team's settings.", -1)

import { onMounted, ref } from "vue";
import axios from "axios";
import { Modal } from "uiv";
import ReportPermissionControl from "./report-permission-control.vue";
import ReportPermissionDialogModel from "./report-permission-dialog-model";


export default /*#__PURE__*/_defineComponent({
  __name: 'report-permission-dialog',
  props: {
    refreshPageOnChange: { type: Boolean, default: false }
  },
  setup(__props: any, { expose: __expose }) {

const props = __props;

const model = ref<ReportPermissionDialogModel>(new ReportPermissionDialogModel());

const shown = ref(false);

onMounted(() => {
  axios.get("/api/reportpermissions/").then((resp) => {
    const modelValue = resp.data as ReportPermissionDialogModel;
    model.value = modelValue;
    shown.value = model.value && model.value.ids && model.value.ids.length > 0;
  });
});

function open(): void {
  shown.value = true;
}

function close(): void {
  shown.value = false;
}

function handleChoice(): void {
  if (props.refreshPageOnChange) {
    window.location.reload();
  } else {
    close();
  }
}

__expose({
  open,
  close,
});

return (_ctx: any,_cache: any) => {
  const _component_big = _resolveComponent("big")!

  return (_openBlock(), _createBlock(_unref(Modal), {
    modelValue: shown.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((shown).value = $event)),
    title: "Team Report Permissions",
    footer: false
  }, {
    default: _withCtx(() => [
      _createElementVNode("p", null, " You’re now a member of ‘" + _toDisplayString(model.value.names[0]) + "’" + _toDisplayString(model.value.names.length == 1 ? "" : " and " + (model.value.names.length - 1) + " other team") + _toDisplayString(model.value.names.length > 2 ? "s" : "") + ". ", 1),
      _hoisted_1,
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("p", null, [
            _createVNode(_component_big, null, {
              default: _withCtx(() => [
                _createTextVNode("Allow my team" + _toDisplayString(model.value.names.length > 1 ? "s" : "") + " to see my reports?", 1)
              ]),
              _: 1
            })
          ])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(ReportPermissionControl, {
            ids: model.value ? model.value.ids : [],
            names: model.value ? model.value.names : [],
            onInput: handleChoice
          }, null, 8, ["ids", "names"])
        ])
      ]),
      _hoisted_6
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})